import { render, staticRenderFns } from "./notificationManagement.vue?vue&type=template&id=18c71b9a&scoped=true"
import script from "./notificationManagement.vue?vue&type=script&lang=js"
export * from "./notificationManagement.vue?vue&type=script&lang=js"
import style0 from "./notificationManagement.vue?vue&type=style&index=0&id=18c71b9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c71b9a",
  null
  
)

export default component.exports